import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import ActionItems from './ActionItems';
import AddLanguageButton from 'components/AddLanguageButton';
import { message } from 'antd';
import { handleMessage } from 'utils/helper/message';
import AddModal from './AddModal';
import { ISupportLanguage } from 'utils/types/storyTypes';
import EditModal from './EditModal';
import { useTranslation } from 'react-i18next';
import { IVisible } from '..';

interface IProps {
  data: any;
  setSelectedEl: (value: any) => void;
  visible: IVisible;
  setVisible: React.Dispatch<any>;
  langList: ISupportLanguage[] | null;
  setData: React.Dispatch<any>;
  projectId: string | undefined;
  selected: any;
}

const Table: React.FC<IProps> = ({
  data,
  setSelectedEl,
  visible,
  setVisible,
  langList,
  setData,
  projectId,
  selected,
}) => {
  const { t } = useTranslation();
  const handleAddLanguage = () => {
    setVisible({ ...visible, create: true });
  };
  return (
    <>
      <SectionWarpper>
        <div className='langsTable'>
          <div className='langsTable-first'>
            <p className='title-table'>
              {t(
                'storyEpisodeID.storyTabMenuList.loadingContent.update.language',
              )}
            </p>
          </div>
          <div className='langsTable-second'>
            <p className='title-table'>
              {t(
                'storyEpisodeID.storyTabMenuList.loadingContent.update.loadingName',
              )}
            </p>
          </div>
          <div className='langsTable-third'></div>
          {data?.details?.map((el, i) => {
            return (
              <>
                <div className='langsTable-first'>
                  <p>{el?.lang}</p>
                </div>
                <div className='langsTable-second'>
                  <p>{el?.loading_text}</p>
                </div>
                <div className='langsTable-third'>
                  <ActionItems
                    data={data}
                    elData={el}
                    i={i}
                    setSelectedEl={setSelectedEl}
                    visible={visible}
                    setVisible={setVisible}
                    setData={setData}
                  />
                </div>
              </>
            );
          })}
          <AddLanguageButton handleAddLanguage={handleAddLanguage} />
        </div>
      </SectionWarpper>
      <AddModal
        langList={langList}
        data={data}
        setData={setData}
        visible={visible}
        setVisible={setVisible}
        projectId={projectId}
      />
      <EditModal
        projectId={projectId}
        langList={langList}
        data={data}
        setData={setData}
        visible={visible}
        setVisible={setVisible}
        selected={selected}
      />
    </>
  );
};

export default Table;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .langsTable {
    display: flex;
    flex-wrap: wrap;
  }
  .langsTable-first {
    width: 40%;
  }
  .langsTable-second {
    width: 40%;
  }
  .langsTable-third {
    width: 20%;
    display: flex;
    justify-content: end;
    & > * + * {
      margin-left: 16px;
    }
  }
  .langsTable-first,
  .langsTable-second,
  .langsTable-third {
    border-bottom: 1px solid ${theme.colors.dark_200};
    padding: 12px;
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.fontWeights.medium};
      line-height: 16px;
      letter-spacing: 0.2px;
      text-transform: capitalize;
    }
  }
  .title-table {
    font-size: ${theme.fontSizes.normal} !important;
    font-weight: ${theme.fontWeights.bold} !important;
  }
`;
